import { useMemo, useState } from "react";
import Select from "react-select";
import { Product } from "../../dto/commons";
import { useProducts } from "../../hooks/use-commons";
import useDebounce from "../../hooks/utils/use-debounce";

interface Props {
  id?: string;
  selectedProducts: Product[];
  onChange: (newSelected: Product[]) => void;
}

export default function ProductSelector({
  selectedProducts,
  onChange,
  id = "productSelector",
}: Props) {
  const [inputValue, setInputValue] = useState("");
  const name = useDebounce(inputValue, 300);

  const { data: products, isLoading } = useProducts({
    name,
  });

  const productOptions = useMemo(
    () => products?.map((p) => ({ value: p.id, label: p.name })) || [],
    [products],
  );
  return (
    <Select
      id={id}
      options={productOptions}
      isMulti
      isLoading={isLoading}
      placeholder="All Products"
      inputValue={inputValue}
      onInputChange={setInputValue}
      classNames={{
        control: () => "!border-gray-200",
      }}
      value={selectedProducts.map((p) => ({ value: p.id, label: p.name }))}
      onChange={(selectedOptions) => {
        onChange(
          selectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
            default_code: null,
          })),
        );
      }}
      className="mt-1"
    />
  );
}
